export default __webpack_public_path__ + "static/media/refund.cd2056b6.svg";